import { z } from "zod";
import { WeekdayNumbers } from "luxon";

export const WeekdayEnum = z.enum(["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"]);

export type Weekday = z.infer<typeof WeekdayEnum>;

const _weekdayNumberByWeekday = Object.fromEntries(WeekdayEnum.options.map((it, index) => [it, index + 1]));

export function weekdayToWeekdayNumber(weekday: Weekday): WeekdayNumbers {
  return _weekdayNumberByWeekday[weekday] as WeekdayNumbers;
}
